import React from "react";

export default function SQLServer_RAND() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_RAND</h1>
      <p>This is the SQLServer_RAND component generated from the SQL JSON.</p>
    </div>
  );
}
